import Axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as Action from 'actions/Like';

export function* onCreateLikeRequest({ payload, cb }) {
  const { postId, item, ...body } = payload;
  
  try {
    const { data } = yield Axios.post('/api/like/create', body);
    yield put(Action.onCreateLikeSuccess({ ...data, postId, item }));
    cb && cb(null, data);
  } catch (e) {
//    yield put(Action.onCreateLikeFailure({ message: e, ...payload })); NOT YET IMPLEMENTED
    cb && cb(e);
  }
}

export function* onDeleteLikeRequest({ payload, cb }) {

  try {
    const { data } = yield Axios.delete('/api/like/deleteUsingEntityTypeAndEntityId', { data: { entityId: payload.entityId, entityType: payload.entityType }});
    yield put(Action.onDeleteLikeSuccess(payload));
    cb && cb(null, data);
  } catch (e) {
//    yield put(Action.onDeleteLikeFailure({ message: e, ...payload })); NOT YET IMPLEMENTED
    cb && cb(e);
  }
}